import React from "react"
import { Container, Grid } from "@material-ui/core";
import CbAgentes from "../CbAgentes"
import CbMeses from "../CbMeses"
import TPagoAgente from "../TPagoAgente"
import HomePage from "../../Home"

const VReportePagos = () => {
    return(
        <HomePage>        
            <Container>
                <Grid item xs={12}>
                    <CbAgentes esPago={true} esReporte={false} />
                    <CbMeses />
                </Grid>
                <Grid item xs={12}>
                    <TPagoAgente />
                </Grid>
            </Container>
        </HomePage>
    )
}

export default VReportePagos